// extracted by mini-css-extract-plugin
export default {"root":"mainNavigation_root__QEWRo"};